<div class="container my-5">
    <div class="row">
        <div class="col-sm-12 col-md-5 col-lg-5">
            <p>Realizamos acciones de prevención, intervención médica y capacitación en salud y psico emocional y espiritual en comunidades marginadas de la Ciudad de México y del Estado de México.</p>
            <p>Apoyamos con consultas médicas, cirugías, acompañamiento espiritual y formación en la prevención a personas vulnerables que no cuenten con seguro médico,</p>
            <ul>
                <li><p>Difundir las acciones de la Red a actores estratégicos y público en general.</p></li>
                <li><p>Prevención</p></li>
                <li><p>Medicina integrativa, cirugías gratuitas</p></li>
                <li><p>Mostrar el calendario de eventos a realizar por la red de Salud</p></li>
            </ul>
        </div>

        <div class="col-sm-12 col-md-7 col-lg-7">
            <div class="chart-size mt-5">
                <canvas mdbChart
                [chartType]="chartType"
                [datasets]="chartDatasets"
                [labels]="chartLabels"
                [colors]="chartColors"
                [options]="chartOptions"
                [legend]="true"
                (chartHover)="chartHovered($event)"
                (chartClick)="chartClicked($event)">
                </canvas>
                <p class="mt-3 text-center p-nota">"Atención a personas de bajos recursos sin seguros de salud."</p>
            </div>
            
        </div>

        

    </div>
</div>